const { loadStoriesPlayer } = require('../storiesPlayer/bundle');
const { storiesAdOptions } = require('../storiesPlayer/adOptions');
const { resolveStoriesAdContext } = require('../../adInitializer');
const { getBrandConfig } = require('../../brandConfigs');

// On the Shows site the video is what the reader came for, so its ads are
// In-stream (plcmt 1) under Google's video policy; the homepage widget is not.
const IN_STREAM_SURFACES = new Set(['watch_page', 'show_page', 'shows_home']);

// All surfaces share playback; ad-free surfaces skip ad identity and SDK setup.
async function createShowsPlayer(options = {}) {
  const { container, clips = [], preview = false, signal } = options;
  const clip = clips.find((item) => item.id === options.startVideoId) || clips[0];
  const brand = options.publication || (clip?.playlist === 'mtlblog' ? 'mtlblog' : 'narcity');
  const language = options.language || clip?.language || 'en';
  // The player bundle downloads while the ad context resolves.
  const playerModule = loadStoriesPlayer();
  playerModule.catch(() => {});
  let adOptions = { adsEnabled: false };
  if (!preview && options.ads?.adsEnabled !== false) {
    const ctx = await resolveStoriesAdContext(brand, options.ads || {});
    const plcmt = IN_STREAM_SURFACES.has(options.surface) ? '1' : '2';
    adOptions = storiesAdOptions(getBrandConfig(brand), ctx, { ...options.ads, plcmt }, { useFwjsonLang: true }, language);
  }
  const { StoriesPlayerCore } = await playerModule;
  if (signal?.aborted) return null;
  const player = new StoriesPlayerCore({
    ...adOptions, container, clips, language, brand, showAware: true, showPanel: options.showPanel !== false,
    startVideoId: clip?.id, playlist: clip?.playlist,
    analyticsEnabled: !preview, analyticsEndpoint: options.analyticsEndpoint,
    surface: options.surface || 'show_page', placementBrand: options.publication || 'shows', placementId: options.placementId || options.surface || 'show_page',
    stickyEnabled: !preview && options.stickyEnabled !== false,
    preferSound: !preview && options.preferSound === true,
    onClipChange: options.onClipChange, onPlaybackError: options.onPlaybackError
  });
  container.__millaStoriesPlayerInstance = player;
  await player.init();
  return player;
}
module.exports = { createShowsPlayer };
